<template>
    <div id="asset-generic-card-minimalist-component" class="h-100">
        <template v-if="is_mobile">
            <v-card
                :class="`${is_selected ? 'minimalist-asset-card-selected' : 'minimalist-asset-card'} h-100 text-center pointer`"
                elevation="0"
            >
                <v-card-text class="pa-1">
                    <div class="text-center font-12 text-overflow-ellipsis">
                        {{ asset.name }}
                    </div>

                    <div
                        v-if="asset.internal_reference || asset.code_asset"
                        class="font-weight-bold font-10 font-color-medium text-overflow-ellipsis"
                    >
                        <span v-if="asset.internal_reference">{{ asset.internal_reference }}</span>
                        <span v-if="asset.internal_reference && asset.code_asset"> | </span>
                        <span v-if="asset.code_asset">{{ asset.code_asset }}</span>
                    </div>

                    <template v-for="(n, index_model) in total_models">
                        <div :key="n" class="mb-2">
                            <template v-if="configuration[index_model]?.['is_required']">
                                <v-progress-linear
                                    :color="
                                        $store.getters['asset_module/liquid_by_id_module_and_id_asset_and_model'](
                                            asset_module.id_module,
                                            asset.id_asset,
                                            index_model
                                        )?.color || '#9399a3'
                                    "
                                    :value="getConfigurationDatatableAssetVisionData(asset, index_model, 'percent')"
                                    height="4"
                                    rounded
                                />
                            </template>

                            <template v-else>
                                <v-progress-linear color="#9399a3" height="4" rounded />
                            </template>
                        </div>
                    </template>

                    <div class="font-10 font-color-light line-height-12">
                        <v-icon x-small> mdi-map-marker-outline</v-icon>
                        {{ asset.domicile.address }}<br />
                        {{ asset.domicile.postal_code }} {{ asset.domicile.city }}
                    </div>
                </v-card-text>
            </v-card>
        </template>

        <template v-else>
            <div class="position-relative">
                <v-card
                    :class="`${is_selected ? 'minimalist-asset-card-selected' : 'minimalist-asset-card'} desktop-asset-card h-100 pointer`"
                    data-cy="minimalist-asset-card"
                    elevation="0"
                >
                    <v-card-text class="h-100 position-relative">
                        <v-tooltip open-delay="200" top>
                            {{ asset.name }}

                            <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="font-weight-bold font-18 text-overflow-ellipsis font-color-default"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    {{ asset.name }}
                                </div>
                            </template>
                        </v-tooltip>

                        <v-tooltip v-if="asset.internal_reference || asset.code_asset" open-delay="200" top>
                            {{ [asset.internal_reference, asset.code_asset].filter(Boolean).join(' | ') }}

                            <template v-slot:activator="{ on, attrs }">
                                <div
                                    class="font-weight-bold font-14 font-color-medium text-overflow-ellipsis"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <span v-if="asset.internal_reference">{{ asset.internal_reference }}</span>
                                    <span v-if="asset.internal_reference && asset.code_asset"> | </span>
                                    <span v-if="asset.code_asset">{{ asset.code_asset }}</span>
                                </div>
                            </template>
                        </v-tooltip>

                        <v-tooltip open-delay="200" top>
                            {{ displayToHumanDomicileAddress(asset.domicile) }}

                            <template v-slot:activator="{ on, attrs }">
                                <div class="font-12 ml-n1 mb-3 d-flex line-height-16" v-bind="attrs" v-on="on">
                                    <v-icon class="font-color-medium" dense> mdi-map-marker-outline </v-icon>
                                    <span class="font-color-medium text-overflow-ellipsis">
                                        {{ displayToHumanDomicileAddress(asset.domicile) }}
                                    </span>
                                </div>
                            </template>
                        </v-tooltip>

                        <template v-if="asset.is_subscription_device_active">
                            <template v-if="total_models === 1">
                                <template v-if="configuration[0]?.['is_required']">
                                    <div class="d-flex justify-space-between align-baseline mb-1">
                                        <span
                                            v-if="getConfigurationDatatableAssetVisionData(asset, 0, 'percent')"
                                            class="font-weight-bold font-14"
                                            :style="{
                                                color:
                                                    ($store.getters['asset_module/liquid_by_id_module_and_id_asset_and_model'](
                                                        asset_module.id_module,
                                                        asset.id_asset,
                                                        0
                                                    )?.color || '#9399a3') + ' !important',
                                            }"
                                        >
                                            {{ getConfigurationDatatableAssetVisionData(asset, 0, 'percent') }} %
                                        </span>
                                        <span v-else></span>

                                        <span class="font-color-normal text-no-wrap">
                                            <span
                                                v-if="getConfigurationDatatableAssetVisionData(asset, 0, 'value')"
                                                class="font-weight-bold font-12"
                                            >
                                                {{ getConfigurationDatatableAssetVisionData(asset, 0, 'value') }}
                                                {{ getConfigurationDatatableAssetVisionData(asset, 0, 'unit') }}
                                            </span>
                                            <template
                                                v-if="
                                                    getConfigurationDatatableAssetVisionData(asset, 0, 'value') &&
                                                    getConfigurationDatatableAssetVisionData(asset, 0, 'max')
                                                "
                                            >
                                                /
                                            </template>
                                            <span v-if="getConfigurationDatatableAssetVisionData(asset, 0, 'max')" class="font-10">
                                                {{ getConfigurationDatatableAssetVisionData(asset, 0, 'max') }}
                                                {{ getConfigurationDatatableAssetVisionData(asset, 0, 'unit') }}
                                            </span>
                                        </span>
                                    </div>

                                    <v-progress-linear
                                        :color="
                                            $store.getters['asset_module/liquid_by_id_module_and_id_asset_and_model'](
                                                asset_module.id_module,
                                                asset.id_asset,
                                                0
                                            )?.color || '#9399a3'
                                        "
                                        :value="getConfigurationDatatableAssetVisionData(asset, 0, 'percent')"
                                        height="12"
                                        rounded
                                        class="mb-3"
                                    />
                                </template>

                                <template v-else>
                                    <div class="d-flex justify-center mb-3">
                                        <v-icon class="font-color-light"> mdi-cancel</v-icon>
                                    </div>
                                </template>
                            </template>

                            <template v-else>
                                <div class="d-flex flex-column gap-2 mb-3">
                                    <template v-for="(n, index_model) in total_models">
                                        <div :key="n" class="position-relative">
                                            <div
                                                v-if="getConfigurationDatatableAssetVisionData(asset, index_model, 'percent')"
                                                class="font-weight-bold font-12 mb-1"
                                                :style="{
                                                    color:
                                                        ($store.getters['asset_module/liquid_by_id_module_and_id_asset_and_model'](
                                                            asset_module.id_module,
                                                            asset.id_asset,
                                                            index_model
                                                        )?.color || '#9399a3') + ' !important',
                                                }"
                                            >
                                                {{ getConfigurationDatatableAssetVisionData(asset, index_model, 'percent') }} %
                                            </div>
                                            <v-progress-linear
                                                v-if="configuration[index_model]?.['is_required']"
                                                :color="
                                                    $store.getters['asset_module/liquid_by_id_module_and_id_asset_and_model'](
                                                        asset_module.id_module,
                                                        asset.id_asset,
                                                        index_model
                                                    )?.color || '#9399a3'
                                                "
                                                :value="getConfigurationDatatableAssetVisionData(asset, index_model, 'percent')"
                                                height="12"
                                                rounded
                                            />
                                            <v-progress-linear v-else color="#9399a3" height="12" rounded />
                                        </div>
                                    </template>
                                </div>
                            </template>

                            <template v-for="device in asset.devices">
                                <div :key="device.id_device">
                                    <div class="display-flex-align-center gap-2 mb-1">
                                        <img
                                            v-if="!isErrorOnDeviceReferentielImage"
                                            :src="device.path_image_device_referentiel"
                                            height="28"
                                            v-on:error="isErrorOnDeviceReferentielImage = true"
                                        />
                                        <v-icon v-if="isErrorOnDeviceReferentielImage" small> mdi-access-point-network </v-icon>

                                        <v-tooltip open-delay="200" top>
                                            {{ device.device_number }}

                                            <template v-slot:activator="{ on, attrs }">
                                                <span class="font-14 font-color-default text-overflow-ellipsis" v-bind="attrs" v-on="on">
                                                    {{ device.device_number }}
                                                </span>
                                            </template>
                                        </v-tooltip>
                                    </div>

                                    <div class="d-flex justify-space-between align-center">
                                        <ChipsLastStatement :date="device.date_last_emission" colorless />

                                        <div class="display-flex-align-center font-15 font-color-medium">
                                            {{ device.battery }} %
                                            <v-icon v-if="device.battery" class="ml-1 rotate-90">
                                                {{
                                                    device.battery > 80
                                                        ? 'mdi-battery'
                                                        : device.battery > 50
                                                        ? 'mdi-battery-80'
                                                        : device.battery > 20
                                                        ? 'mdi-battery-50'
                                                        : 'mdi-battery-20'
                                                }}
                                            </v-icon>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </template>

                        <template v-else>
                            <div class="d-flex align-center justify-center flex-column gap-1 h-70">
                                <v-icon class="font-color-light" x-large>mdi-cancel</v-icon>
                                <p class="font-color-light text-uppercase mb-1">Abonnement expiré</p>
                            </div>
                        </template>
                    </v-card-text>
                </v-card>
            </div>
        </template>
    </div>
</template>

<script>
import ChipsLastStatement from '@/components/global/containment/ChipsLastStatement.vue'
import useAsset from '@/mixin/useAsset'
import displayHuman from '@/mixin/displayHuman'

export default {
    name: 'AssetGenericCardMinimalistComponent',
    components: { ChipsLastStatement },
    mixins: [useAsset, displayHuman],
    props: {
        asset: {
            type: Object,
            required: true,
        },
        asset_module: {
            type: Object,
            required: true,
        },
        is_selected: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            isErrorOnDeviceReferentielImage: false,
        }
    },
    computed: {
        total_models() {
            return this.asset_module.total_models || 0
        },
        configuration() {
            return this.asset.configuration
        },
    },
}
</script>